export function fetchData (url, data, success, errorFn) {
	const params = typeof data === 'string'
		? data
		: Object.keys(data).map(
			k => {
				return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
			}
		).join('&')
	// Default options are marked with *
	return fetch(`${url}?${params}`, {
		// body: JSON.stringify(data), // must match 'Content-Type' header
		cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
		// credentials: 'same-origin', // include, same-origin, *omit
		headers: {
			'Content-Type': 'application/json'
		},
		method: 'GET' // *GET, POST, PUT, DELETE, etc.
		// mode: 'cors' // no-cors, cors, *same-origin
		// redirect: 'follow', // manual, *follow, error
		// referrer: 'no-referrer' // *client, no-referrer
	})
		.then(response => response.json())
		.catch(error => {
			if (errorFn) {
				errorFn(error)
			}
			console.error('Error:', error)
		})
		.then(result => {
			if (success) {
				success(result)
				// success(JSON.stringify(result, null, 2))
			}
			// console.info('Success:', result.status)
		})
}

export async function fetchContent (url) {
	const headers = new Headers()
	headers.append('Accept', 'text/html')
	const response = await fetch(url, {
		cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
		method: 'GET',
		headers
	})

	// the server responds with confirmation and the image size
	return response.text()
}

export function fetchWithTimeout (url, options, timeout = 7000) {
	return Promise.race([
		fetch(url, options),
		new Promise((_, reject) =>
			setTimeout(() => reject(new Error('timeout')), timeout)
		)
	])
}

export async function asyncFetchData (url, data) {
	let _url
	const h = new Headers()

	if (data) {
		const params = typeof data === 'string' ?
			data :
			Object.keys(data).map(
				k => {
					return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
				},
			).join('&')
		_url = `${url}?${params}`
	} else {
		_url = `${url}`
	}

	const response = await fetch(new Request(_url, {
		method: 'GET',
		headers: h,
	}))

	// the server responds with confirmation and the image size
	const result = await response.json()
	return result
}

export default fetchData
